import BlockedUserComponent from './components/BlockedUserComponent';
import type { AuthProviderValue, UseRequireAuthInterface } from './types';
import { AuthContext } from './authContext';
import { authRules } from './rules';
import { exitAppWithRedirect, getRedirectUrl } from './redirects';
import { useContext, useEffect } from 'react';

export const useRequireAuth = ({
  onNotSignedIn = exitAppWithRedirect,
  onMissingTwoFactorAuth = exitAppWithRedirect,
  onMissingStrongAuth = exitAppWithRedirect,
  onBlocked,
  requireStrongAuth = false,
  currentPathname,
  onMissingRecentStrongAuth = exitAppWithRedirect,
  queryString,
  brand,
  isInWebView,
}: UseRequireAuthInterface): AuthProviderValue => {
  const auth = useContext(AuthContext);

  useEffect(() => {
    const rules = authRules(auth, requireStrongAuth);

    const to = getRedirectUrl({
      rules,
      brand,
      isInWebView,
      currentPathname,
      queryString,
    });

    if (rules.isNotLoggedIn()) {
      onNotSignedIn(to);
    } else if (rules.isMissingRecentStrongAuth()) {
      onMissingRecentStrongAuth(to);
    } else if (rules.isBlocked()) {
      onBlocked(<BlockedUserComponent brand={brand} />);
    } else if (rules.isMissingStrongAuth()) {
      onMissingStrongAuth(to);
    } else if (rules.isMissingTwoFactorAuth()) {
      onMissingTwoFactorAuth(to);
    }
  }, [requireStrongAuth, currentPathname, queryString, brand, isInWebView]);

  return auth;
};
